import api from "@/services/api.service";

export default {
 name: 'request-contact',
 components: {},
 props: {
  caption: {
    type: String,
    default: "Request Contact list"
  },
  hover: {
    type: Boolean,
    default: true
  },
  striped: {
    type: Boolean,
    default: true
  },
  bordered: {
    type: Boolean,
    default: false
  },
  small: {
    type: Boolean,
    default: false
  },
  fixed: {
    type: Boolean,
    default: false
  }
},
data() {
  return {
    icon: 'fa fa-sort',
    selcol: '',    
    items: [],
    fields: [
    { key: "#" },
    { key: "actions", stickyColumn: true } ],
    sech: {},
    currentPage: 1,
    currentSortDir:'desc',    
    perPage: 10,
    totalRows: null,
    totalMarketingRequest: 0,
    filter_element:[],
    filter_criteria:[],
    isBusy: true,
    delete_ids: [],
    allSelected: false,
    isApproved : true,
    colName : '',
    permission_list: false,
    superAdmin: false,
    permission_approveContacts: false,
    permission_deleteRequestContact: false
  };
},
computed: {},
mounted() {},
async created() {
  let response = await api.post("users/user-permissions");
    const permissions = [];
    response.data[0].permission.forEach( function(element) {                
      permissions.push(element.action)
    }.bind(this));
    if(permissions.includes("request_contact_list_vendor_event") == true || permissions.includes("approve_contact_vendor_event") == true ){
      this.getMarketingRequestContacts();
      this.permission_list = permissions.includes("request_contact_list_vendor_event");
      this.permission_approveContacts = permissions.includes("approve_contact_vendor_event");
      this.permission_deleteRequestContact = permissions.includes("delete_request_contact_event");
    }else if(response.data[0].role == 'super_admin'){
      this.getMarketingRequestContacts();  
      this.superAdmin = true;
    }else if(permissions.includes("list_event") == true || permissions.includes("add_event") == true){
        this.makeToast("Permission denied","Alert","warning",6000);
        this.$router.push({name: 'List Event'});
    }else{
        this.makeToast("Permission denied","Alert","warning",6000);
        this.$router.push({name: 'Admin Dashboard'});
    }
},
watch: {
  currentPage: {
    handler: function(page) {     
        // this.getMarketingRequestContacts(page)
        this.toSort(this.colName,page);

    }
  }
},
methods: {
  makeToast(message = "", title = "Alert", variant = "warning") {
    this.toastCount++;
    this.$root.$bvToast.toast(message, {
      title: title,
      variant: variant,
      autoHideDelay: 3000
    });
  },
  selectAll: function(e) {
    this.delete_ids = [];            
    if(e.target.checked){
      for (var item in this.items) {
        this.delete_ids.push(this.items[item].id.toString());
      }                
    }            
  },
  selectOne(){
    this.allSelected = false;            
  },
  async toSort (items,page = 1)
  {
    if (items != "actions" && items != "#") {                
    this.items = [];    
    
    if(page == 1)
    if(items == this.colName)
    this.currentSortDir = this.currentSortDir==='asc'?'desc':'asc'; 
    
    this.sech.marketing_event_id = this.$route.params.id;
    this.colName = items;
    this.isBusy=true;
    let response = await api.post("marketing-event/get-marketing-request-contacts",{ page:page,columnname:items,sortType:this.currentSortDir,marketing_event_id:this.sech.marketing_event_id,paginateVal:this.perPage});
    if (response.status == "success") {
        if (response.data.data != "") {        
          if(this.currentSortDir == 'asc'){
              this.icon1 = 'fa fa-sort-up';                             
              this.selcol = items;        
          } else{ 
              this.icon1 = 'fa fa-sort-down';                             
              this.selcol = items;
          }                        
          response.data.data.forEach( function(element) {                    
            this.items.push(JSON.parse(element.exported_data));  
          }.bind(this));          

          this.totalMarketingRequest = response.data.total;
          this.currentPage = response.data.current_page;
          this.perPage = response.data.per_page;
        } else {
        this.items = [];
      }
    }
    this.isBusy = false;
  }
  },
  async getMarketingRequestContacts(page) {
    this.items = [];
    this.sech.page = page;
    this.sech.marketing_event_id = this.$route.params.id;
    this.sech.request_id = this.$route.params.request_id;
    let response = await api.post("marketing-event/get-marketing-request-contacts", this.sech);          
    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);
    if (response.status == "success") {
      if (response.data.data != "") {  
        //GET ALL HEADERS FROM JSON
        this.isApproved = (response.data.data[0].event_request.status == 'Done'?true:false);
        var columns = Object.keys(Object.assign({}, ...[JSON.parse(response.data.data[0].exported_data)]));

        columns.splice(0,1);
        columns.map((h) => {
         this.fields.push({key: h, sortable: false}) 
        });

        //Iterate Data 
        response.data.data.forEach( function(element) {                    
          //var id = [{id:element.id}];
          this.items.push(JSON.parse(element.exported_data));  
        }.bind(this));

        //this.fields.push({ key: "actions" });
        this.filter_element = JSON.parse(response.data.data[0].event_request.contact_values);
        this.totalMarketingRequest = response.data.total;
        this.currentPage = response.data.current_page;
        this.perPage = response.data.per_page;

        this.pageOptions.forEach(element => {
          if(element.value > this.totalMarketingRequest){
              var indexOf = this.pageOptions.indexOf(element);
              if( indexOf != 0 )
              this.pageOptions.splice(indexOf)
          }
        });
        if(this.totalMarketingRequest <= 500)
        this.pageOptions.push({text:'All',value:this.totalMarketingRequest});
      } else {
        this.items = [];
      }
    }      
    this.isBusy = false;
  },
  getRowCount(items) {
    return items.length;
  },
  multipleDelete(){
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event Request Contacts?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(this.delete_ids, 0);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },singleDelete(id, index) {
    this.$bvModal
    .msgBoxConfirm("Are you sure want to delete this Marketing Event Request Contact?")
    .then(value => {
      if (value) {
        this.deleteMarketingContact(id, index);
      } else {
        return;
      }
    })
    .catch(function() {
      return;
    });
  },
  async deleteMarketingContact(id, index) {

    let response = await api.post("admin/marketing-event/delete-request-contact",
      { id: id , marketing_event_id : this.$route.params.id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {

      if(index == 0){
        this.items = [];
        this.getMarketingRequestContacts();
      }
      else
        this.items.splice(index, 1);

      this.makeToast(response.message || `Marketing Event delete successful.`,"Alert","success");
    } 
    else 
      this.makeToast(`Marketing Event not deleted.`, "Alert", "danger");
  },
 async approveRequestedContacts(){

    let response = await api.post("admin/marketing-event/approve-requested-contacts",
      {marketing_event_id : this.$route.params.id , request_id : this.$route.params.request_id });

    if (!response)
      this.makeToast("Something went to wrong please try again","Alert","danger",6000);

    if (response.status == "success") {
      this.isApproved = true;
      this.makeToast(response.message || `Marketing Event approved successful.`,"Alert","success");
    } 
    else{
      for (var error in response.errors)
                        this.makeToast(response.errors[error], 'Alert', 'danger', 6000)
    } 
  }
}
};
